import Dashboard from "./Dashboard";
import Editor from "./Editor";
import Login from "./Login";

export {
    Dashboard,
    Login,
    Editor
};
